import { Component } from '@angular/core';

@Component({
  selector: 'app-item-sales-summary-by-customer',
  standalone: false,
  
  templateUrl: './item-sales-summary-by-customer.component.html',
  styles: ``
})
export class ItemSalesSummaryByCustomerComponent {

}
